import { Col, Row } from 'antd';
import React from 'react';
import { urlPrint } from '../actions';
import { columns, IDENTIFIER_TYPE_MAP, TAXPAYER_TYPE_PREFIX } from '../constants';
import { GetResultsTableProps } from '../find-taxpayer-service.type';
import { TaxPeriodsTable } from './tax-period-table';
import { localize } from 'mixins/helpers';
import { PrintIcon } from 'mixins/icons/booking-queue.icons';
import CmsTable from 'mixins/ui/cms-table';
import PrintForm2 from 'mixins/ui/print-form-2';

export function GetResultsTable({
    noResNumber,
    item,
    translations,
    type,
    values,
}: GetResultsTableProps) {
    const identifier = IDENTIFIER_TYPE_MAP[type];

    return (
        <div className="results-container">
            <CmsTable
                noResNumber={noResNumber}
                resultCard={item?.name}
                columns={columns(translations)}
                dataSource={item ? [item] : []}
                size="large"
                translations={translations}
                type="default"
                pagination={false}
            >
                <Col
                    md={12}
                    xs={12}
                    lg={12}
                >
                    <div>{localize(identifier, translations)}</div>
                    <div>{item?.iinBin}</div>
                </Col>
                <Col
                    md={12}
                    xs={12}
                    lg={12}
                >
                    <div>{localize('type', translations)}</div>
                    <div>{localize(`${TAXPAYER_TYPE_PREFIX}-${type}`, translations)}</div>
                </Col>
            </CmsTable>

            {type === 'UL' && item?.ulTaxInfo?.length > 0 && (
                <TaxPeriodsTable
                    translations={translations}
                    ulTaxInfo={item.ulTaxInfo}
                />
            )}
            {item && (
                <Row>
                    <PrintForm2
                        apiUrl={
                            type === 'FL'
                                ? urlPrint + '?token=4f9fc460-05fb-438c-9d99-1dcb52e95503'
                                : urlPrint
                        }
                        isPost
                        params={
                            ['UL', 'IP'].includes(type)
                                ? {
                                      iinBin: item.iinBin,
                                      organizationName: item.name,
                                      type
                                  }
                                : values
                        }
                        icon={<PrintIcon />}
                        translations={translations}
                    />
                </Row>
            )}
        </div>
    );
}
